import "./index.css";

const SchoolEducationCards = () => {
  return (
    <div className="cards-container">
      <div className="education-text-container">
        <h1 className="education-text">School Education</h1>
        <p className="education-description">
          At ASWA, we believe in the transformative power of education to shape
          a better society, where every child has the opportunity to thrive and
          contribute positively. Through our collaborative efforts with
          government schools in Andhra Pradesh & Telangana under the "VIKAS"
          project, we aim to strengthen the educational system for all,
          including the disadvantaged. Building on our past initiatives like
          VIKAS PRIMARY, VIKAS SECONDARY, and VIKAS CAREER GUIDANCE, we have
          expanded our focus to address the root causes of societal issues
          through education. With support from the Wipro Foundation's fellowship
          and CHDHC Project, we are committed to fostering systemic change by
          enhancing literacy, language, and library interventions while
          empowering educators, NGOs, and individuals alike. Join us in our
          journey towards a brighter, more equitable future.
        </p>
      </div>
      <div className="card-app-container">
        <div className="card-image">
          <img
            src="/Images/schooleducation1.png"
            alt="Education"
            className="school-education-images"
          />
        </div>
        <div className="card-description-container">
          <h1 className="card-description-heading">
            Foundational Literacy and Numeracy (FLN)
          </h1>
          <p className="card-description">
          Our goal is to enhance underprivileged schools and communities, emphasizing literacy and numeracy skills in children
           through innovative teaching methods. Adopting Maxine Bernstein's "balanced approach" ensures efficient FLN delivery, 
           focusing on classroom strategies, library programs, and teacher practices. We integrate individual factors like culture, socioeconomics, and behavior, fostering a safe and playful learning environment. Our education efforts directly engage six teachers and 219 primary grade students in literacy and numeracy instruction.
          </p>
        </div>
      </div>
      <div className="card-app-container">
        <div className="card-image">
          <img
            src="Images/schooleducation2lg.png"
            alt="Education"
            className="school-education-images"
          />
        </div>
        <div className="card-description-container">
          <h1 className="card-description-heading">
            Children Learning Center (CLC)
          </h1>
          <p className="card-description">
          The Libraries and Children's Literature (LCL) project aims to instill storytelling appreciation in first-generation learners. Its Children's Library fosters a love for reading, nurturing creativity, critical thinking, and communication skills among marginalised children. With 1200+ curated books in Telugu, English, and bilingual, activities engage 60+ children, borrowing 1500+ storybooks in 6–9 months. Along with the above, we also have other initiatives, like Storytime in Schools. Children's Story Time: Online Storytelling
          </p>
        </div>
      </div>
      <div className="card-app-container">
        <div className="card-image">
          <img
            src="/Images/schooleducation3lg.png"
            alt="Education"
            className="school-education-images"
          />
        </div>
        <div className="card-description-container">
          <h1 className="card-description-heading">Children’s Library</h1>
          <p className="card-description">
            The Libraries and Children's Literature (LCL) project aims to instill storytelling appreciation in first-generation learners. Its Children's Library fosters a love for reading, nurturing creativity, critical thinking, and communication skills among marginalized children. With 1200+ curated books in Telugu, English, and bilingual, activities engage 60+ children, borrowing 1500+ storybooks in 6–9 months. Along with the above, we also have other initiatives, like Storytime in Schools Children's Story Time: Online Storytelling
          </p>
        </div>
      </div>
      <div className="card-app-container">
        <div className="card-image">
          <img
            src="/Images/schooleducation4lg.png"
            alt="Education"
            className="school-education-images"
          />
        </div>
        <div className="card-description-container">
          <h1 className="card-description-heading">Career Guidance</h1>
          <p className="card-description">
          Our Career Guidance program was launched to spread awareness about the career options available after 10th grade to secondary school students. Volunteers conduct sessions on personality, goal setting, and career options available after the 10th grade. Post-sessions, every attendee gets a unique guide designed by ASWA that offers clarity on choosing a career path for the next 6–7 years. 
          </p>
        </div>
      </div>
      <div className="card-app-container">
        <div className="card-image">
          <img
            src="/Images/schooleducation5lg.png"
            alt="Education"
            className="school-education-images"
          />
        </div>
        <div className="card-description-container">
          <h1 className="card-description-heading">Project Cheyutha</h1>
          <p className="card-description">
          Financial Support and Guidance to Meritorious Students: Project Cheyutha was launched to offer scholarships to meritorious students coming from economically deprived families. Students who aim to pursue higher education (beyond Grade 10) are eligible for the scholarship. Through Project Cheyutha, we generally extend support for hostel, mess, tuition, and stationery fees. Till now, we have extended support to over 65+ students.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SchoolEducationCards;
